import { useContext } from 'react';
import {
  GroupFeaturesContext,
  AppPlatformContext,
  IsDemoEnvContext,
} from './contexts';

export const useGroupFeatures = () => {
  const context = useContext(GroupFeaturesContext);
  if (context === undefined) {
    throw new Error('useGroupFeatures must be used within ChatCompatabilityProvider');
  }
  return context;
};

export const useAppPlatform = () => {
  const context = useContext(AppPlatformContext);
  if (context === undefined) {
    throw new Error('useAppPlatform must be used within ChatCompatabilityProvider');
  }
  return context;
};

export const useIsDemoEnv = () => {
  const context = useContext(IsDemoEnvContext);
  if (context === undefined) {
    throw new Error('useIsDemoEnv must be used within ChatCompatabilityProvider');
  }
  return context;
};